import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pre-register',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './pre-register.component.html',
  styleUrl: './pre-register.component.scss'
})
export class PreRegisterComponent implements OnInit {
  preRegisterForm!: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient
  ) {
    this.initForm();
  }

  ngOnInit(): void { }

  /**
   * Initialize the reactive form
   */
  private initForm(): void {
    this.preRegisterForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      cid: ['', [Validators.required, Validators.pattern(/^[0-9]{13}$/)]]
    });
  }

  /**
   * Check if field has error
   */
  hasError(fieldName: string): boolean {
    const field = this.preRegisterForm.get(fieldName);
    return !!(field && field.invalid && field.touched);
  }

  /**
   * Get error message for field
   */
  getErrorMessage(fieldName: string): string {
    const field = this.preRegisterForm.get(fieldName);
    if (!field || !field.errors) return '';

    if (field.errors['required']) return 'กรุณากรอกข้อมูล';
    if (field.errors['email']) return 'รูปแบบอีเมลไม่ถูกต้อง';
    if (field.errors['pattern']) {
      if (fieldName === 'cid') return 'รหัสบัตรประชาชนต้องเป็นตัวเลข 13 หลัก';
    }

    return 'ข้อมูลไม่ถูกต้อง';
  }

  /**
   * Submit the form
   */
  onSubmit(): void {
    // Mark all fields as touched to show validation errors
    Object.keys(this.preRegisterForm.controls).forEach(key => {
      this.preRegisterForm.get(key)?.markAsTouched();
    });

    if (this.preRegisterForm.valid) {
      this.isSubmitting = true;

      const formData = this.preRegisterForm.value;

      // Prepare API request body
      // Note: Backend still requires password field, sending default value
      // TODO: Update backend to remove password requirement
      const requestBody = {
        email: formData.email,
        cid: formData.cid,
        // password: formData.cid, // Use CID as temporary password
        isActive: true
      };

      console.log('Pre-registration data:', requestBody);

      // Call API
      this.http.post(`${environment.apiUrl}/users/register`, requestBody).subscribe({
        next: (response) => {
          console.log('Registration successful:', response);
          alert('ลงทะเบียนเบื้องต้นสำเร็จ! กรุณาเข้าสู่ระบบ');
          this.isSubmitting = false;
          this.router.navigate(['/login']);
        },
        error: (error) => {
          console.error('Registration error:', error);
          let errorMessage = 'เกิดข้อผิดพลาดในการลงทะเบียน';

          if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.status === 409) {
            errorMessage = 'อีเมลนี้ถูกใช้งานแล้ว';
          } else if (error.status === 400) {
            errorMessage = 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง';
          }

          alert(errorMessage);
          this.isSubmitting = false;
        }
      });
    }
  }

  /**
   * Cancel and go back to login
   */
  cancel(): void {
    if (confirm('คุณต้องการยกเลิกการลงทะเบียนหรือไม่?')) {
      this.router.navigate(['/login']);
    }
  }
}
